<!-- Desktop & Mobile Navigation -->
<nav class="navbar" [class.navbar--dark]="mode === 'dark'" [class.navbar--light]="mode === 'light'">
  <div class="navbar-container">

    <!-- Logo -->
    <div class="navbar-logo">
      <a [routerLink]="homeLink" (click)="closeAllDropdowns()">
        <mb-logo [showTagline]="false" [variant]="logoVariant" />
      </a>
    </div>

    <!-- Desktop Navigation Links -->
    <div class="navbar-links">
      <!-- <a routerLink="/quienes-somos" class="navbar-link" (click)="closeAllDropdowns()">Quiénes somos</a> -->

      <!-- Servicios Dropdown -->
      <div class="navbar-dropdown">
        <button class="navbar-link navbar-link--dropdown" [class.navbar-link--active]="isServiciosOpen" (click)="toggleServiciosDropdown()">
          Servicios
          <mb-icon name="ChevronDown" size="sm" [customSize]="24" />
        </button>

        <!-- Servicios Dropdown Menu -->
        <div class="navbar-dropdown-menu" *ngIf="isServiciosOpen">
          <div class="navbar-dropdown-content">
            <div class="navbar-dropdown-grid">
              <!-- Row 1 -->
              <a routerLink="/services/psicologia" class="navbar-dropdown-card" (click)="closeAllDropdowns()">
                <div class="navbar-dropdown-card-content">
                  <h3 class="navbar-dropdown-card-title">Psicología</h3>
                  <p class="navbar-dropdown-card-description">
                    Acompañamiento emocional para entenderte mejor, manejar tus pensamientos y fortalecer tu bienestar mental.
                  </p>
                </div>
                <div class="navbar-dropdown-card-icon">
                  <mb-icon-container mode="light">
                    <mb-icon name="ArrowRight" size="md"></mb-icon>
                  </mb-icon-container>
                </div>
              </a>

              <a routerLink="/services/psiquiatria" class="navbar-dropdown-card" (click)="closeAllDropdowns()">
                <div class="navbar-dropdown-card-content">
                  <h3 class="navbar-dropdown-card-title">Psiquiatría</h3>
                  <p class="navbar-dropdown-card-description">
                    Evaluación médica especializada para equilibrar tu salud mental con apoyo clínico y, si es necesario, tratamiento farmacológico.
                  </p>
                </div>
                <div class="navbar-dropdown-card-icon">
                  <mb-icon-container mode="light">
                    <mb-icon name="ArrowRight" size="md"></mb-icon>
                  </mb-icon-container>
                </div>
              </a>

              <a routerLink="/services/nutricion" class="navbar-dropdown-card" (click)="closeAllDropdowns()">
                <div class="navbar-dropdown-card-content">
                  <h3 class="navbar-dropdown-card-title">Nutrición</h3>
                  <p class="navbar-dropdown-card-description">
                    Guía personalizada para mejorar tu relación con la comida y cuidar tu cuerpo desde el equilibrio y la conciencia.
                  </p>
                </div>
                <div class="navbar-dropdown-card-icon">
                  <mb-icon-container mode="light">
                    <mb-icon name="ArrowRight" size="md"></mb-icon>
                  </mb-icon-container>
                </div>
              </a>
            </div>
            <div class="navbar-dropdown-grid-2">
              <!-- Row 2 -->
              <a routerLink="/services/coaching" class="navbar-dropdown-card" (click)="closeAllDropdowns()">
                <div class="navbar-dropdown-card-content">
                  <h3 class="navbar-dropdown-card-title">Coaching</h3>
                  <p class="navbar-dropdown-card-description">
                    Espacio de crecimiento personal y profesional para alcanzar tus metas con claridad, propósito y confianza.
                  </p>
                </div>
                <div class="navbar-dropdown-card-icon">
                  <mb-icon-container mode="light">
                    <mb-icon name="ArrowRight" size="md"></mb-icon>
                  </mb-icon-container>
                </div>
              </a>

              <a routerLink="/services/tanatologia" class="navbar-dropdown-card" (click)="closeAllDropdowns()">
                <div class="navbar-dropdown-card-content">
                  <h3 class="navbar-dropdown-card-title">Tanatología</h3>
                  <p class="navbar-dropdown-card-description">
                    Acompañamos emocionalmente para aceptar el ciclo de la vida, encontrar paz y resignificar la ausencia con herramientas de contención y autoconocimiento.
                  </p>
                </div>
                <div class="navbar-dropdown-card-icon">
                  <mb-icon-container mode="light">
                    <mb-icon name="ArrowRight" size="md"></mb-icon>
                  </mb-icon-container>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Explora Dropdown -->
      <div class="navbar-dropdown">
        <button class="navbar-link navbar-link--dropdown" [class.navbar-link--active]="isExploraOpen" (click)="toggleExploraDropdown()">
          Explora
          <mb-icon name="ChevronDown" size="sm" [customSize]="24" />
        </button>

        <!-- Explora Dropdown Menu -->
        <div class="navbar-dropdown-menu navbar-dropdown-menu--explora" *ngIf="isExploraOpen">
          <div class="navbar-explora-grid">
            <a routerLink="/for-business" class="navbar-explora-card" (click)="closeAllDropdowns()">
              <div class="navbar-explora-card-icon">
                <mb-icon-container mode="light">
                  <mb-icon name="Building2" size="md"></mb-icon>
                </mb-icon-container>
              </div>
              <div class="navbar-explora-card-content">
                <h3 class="navbar-explora-card-title">Terapia para Empresas</h3>
                <p class="navbar-explora-card-description">
                  Programas de bienestar emocional para cuidar a tu equipo y tu organización.
                </p>
              </div>
            </a>

            <a routerLink="/specialists" class="navbar-explora-card" (click)="closeAllDropdowns()">
              <div class="navbar-explora-card-icon">
                <mb-icon-container mode="light">
                  <mb-icon name="Users" size="md"></mb-icon>
                </mb-icon-container>
              </div>
              <div class="navbar-explora-card-content">
                <h3 class="navbar-explora-card-title">Nuestros Especialistas</h3>
                <p class="navbar-explora-card-description">
                  Conoce a los psicólogos, psiquiatras y coaches que te acompañan.
                </p>
              </div>
            </a>

            <a routerLink="/blog" class="navbar-explora-card" (click)="closeAllDropdowns()">
              <div class="navbar-explora-card-icon">
                <mb-icon-container mode="light">
                  <mb-icon name="BookOpen" size="md"></mb-icon>
                </mb-icon-container>
              </div>
              <div class="navbar-explora-card-content">
                <h3 class="navbar-explora-card-title">Blog</h3>
                <p class="navbar-explora-card-description">
                  Artículos y recursos sobre salud mental, hábitos y bienestar.
                </p>
              </div>
            </a>

            <a href="https://marketplace.mentebonita.com/" target="_blank" class="navbar-explora-card" (click)="closeAllDropdowns()">
              <div class="navbar-explora-card-icon">
                <mb-icon-container mode="light">
                  <mb-icon name="Store" size="md"></mb-icon>
                </mb-icon-container>
              </div>
              <div class="navbar-explora-card-content">
                <h3 class="navbar-explora-card-title">Marketplace</h3>
                <p class="navbar-explora-card-description">
                  Explora productos y servicios pensados para tu bienestar.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Right Actions -->
    <div class="navbar-actions">
      @if (isLoggedIn) {
        <!-- Logged In Actions -->
        <mb-button size="sm" variant="secondary" [mode]="mode" (click)="goToAccount(); closeAllDropdowns()">
          Mi Cuenta
        </mb-button>
        <mb-button size="sm" variant="primary" [mode]="mode" (click)="logout(); closeAllDropdowns()">
          Cerrar Sesión
        </mb-button>
      }
      @else {
        <!-- Guest Actions -->
        <a routerLink="/auth/login" (click)="closeAllDropdowns()">
          <mb-button size="sm" variant="secondary" [mode]="mode">Iniciar Sesión</mb-button>
        </a>
        <a routerLink="/test" (click)="onComenzarTestClick(); closeAllDropdowns()">
          <mb-button size="sm" variant="primary" [mode]="mode">Comenzar Test</mb-button>
        </a>
      }

      <!-- Country Selector Dropdown -->
      <div class="navbar-dropdown navbar-country" (click)="toggleCountryDropdown()">
        <button class="navbar-country-trigger" [class.navbar-country-trigger--active]="isCountryOpen">
          <img [src]="selectedCountry.flag" [alt]="selectedCountry.name" class="navbar-country-flag" />
        </button>

        <!-- Country Dropdown Menu -->
        <div class="navbar-country-menu" *ngIf="isCountryOpen">
          <button
            *ngFor="let country of countries"
            class="navbar-country-option"
            [class.navbar-country-option--active]="country.code === selectedCountry.code"
            (click)="selectCountry(country); $event.stopPropagation()">
            <div class="w-8 h-8">
              <img [src]="country.flag" [alt]="country.name" class="navbar-country-flag" />
            </div>
            <span class="navbar-country-label">{{ country.label }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu Toggle -->
    <div class="navbar-mobile-toggle">
      <!-- Country Selector (Mobile) -->
      <div class="navbar-dropdown navbar-country" (click)="toggleCountryDropdown()">
        <button class="navbar-country-trigger" [class.navbar-country-trigger--active]="isCountryOpen">
          <img [src]="selectedCountry.flag" [alt]="selectedCountry.name" class="navbar-country-flag" />
        </button>

        <!-- Country Dropdown Menu -->
        <div class="navbar-country-menu" *ngIf="isCountryOpen">
          <button
            *ngFor="let country of countries"
            class="navbar-country-option"
            [class.navbar-country-option--active]="country.code === selectedCountry.code"
            (click)="selectCountry(country); $event.stopPropagation()">
            <div class="w-8 h-8">
              <img [src]="country.flag" [alt]="country.name" class="navbar-country-flag" />
            </div>
            <span class="navbar-country-label">{{ country.label }}</span>
          </button>
        </div>
      </div>

      <button class="navbar-mobile-menu-btn" (click)="toggleMobileMenu()" [attr.aria-label]="isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'">
        <mb-icon [name]="isMobileMenuOpen ? 'X' : 'Menu'" size="md" />
      </button>
    </div>

  </div>
</nav>

<!-- Mobile Menu Overlay -->
<div class="navbar-mobile-overlay" *ngIf="isMobileMenuOpen" (click)="closeMobileMenu()">
  <div class="navbar-mobile-menu" (click)="$event.stopPropagation()">
    <nav class="navbar-mobile-links">
      <!-- <a routerLink="/quienes-somos" class="navbar-mobile-link" (click)="closeMobileMenu()">Quiénes somos</a> -->

      <!-- Mobile Servicios -->
      <button class="navbar-mobile-link navbar-mobile-link--dropdown" [class.navbar-mobile-link--active]="isServiciosOpen" (click)="toggleServiciosDropdown()">
        Servicios
        <mb-icon name="ChevronDown" size="sm" [class.navbar-mobile-icon--rotated]="isServiciosOpen" />
      </button>

      <!-- Mobile Servicios Submenu -->
      <div class="navbar-mobile-submenu" *ngIf="isServiciosOpen">
        <a routerLink="/services/psicologia" class="navbar-mobile-submenu-link" (click)="closeMobileMenu()">Psicología</a>
        <a routerLink="/services/psiquiatria" class="navbar-mobile-submenu-link" (click)="closeMobileMenu()">Psiquiatría</a>
        <a routerLink="/services/nutricion" class="navbar-mobile-submenu-link" (click)="closeMobileMenu()">Nutrición</a>
        <a routerLink="/services/coaching" class="navbar-mobile-submenu-link" (click)="closeMobileMenu()">Coaching</a>
        <a routerLink="/services/tanatologia" class="navbar-mobile-submenu-link" (click)="closeMobileMenu()">Tanatología</a>
      </div>

      <!-- Mobile Explora -->
      <button class="navbar-mobile-link navbar-mobile-link--dropdown" [class.navbar-mobile-link--active]="isExploraOpen" (click)="toggleExploraDropdown()">
        Explora
        <mb-icon name="ChevronDown" size="sm" [class.navbar-mobile-icon--rotated]="isExploraOpen" />
      </button>

      <!-- Mobile Explora Submenu -->
      <div class="navbar-mobile-submenu" *ngIf="isExploraOpen">
        <a routerLink="/for-business" class="navbar-mobile-submenu-link navbar-mobile-submenu-link--icon" (click)="closeMobileMenu()">
          <mb-icon name="Building2" size="sm" [customSize]="20" />
          Terapia para Empresas
        </a>
        <a routerLink="/specialists" class="navbar-mobile-submenu-link navbar-mobile-submenu-link--icon" (click)="closeMobileMenu()">
          <mb-icon name="Users" size="sm" [customSize]="20" />
          Nuestros Especialistas
        </a>
        <a routerLink="/blog" class="navbar-mobile-submenu-link navbar-mobile-submenu-link--icon" (click)="closeMobileMenu()">
          <mb-icon name="BookOpen" size="sm" [customSize]="20" />
          Blog
        </a>
        <a href="https://marketplace.mentebonita.com/" target="_blank" class="navbar-mobile-submenu-link navbar-mobile-submenu-link--icon" (click)="closeMobileMenu()">
          <mb-icon name="Store" size="sm" [customSize]="20" />
          Marketplace
        </a>
      </div>

      <!-- Comenzar Test (Mobile Menu) - Solo para usuarios no logueados -->
      @if (!isLoggedIn) {
        <a routerLink="/test" class="navbar-mobile-link navbar-mobile-link--cta" (click)="onComenzarTestMobileClick(); closeMobileMenu()">
          Comenzar Test
        </a>
      }
    </nav>

    <div class="navbar-mobile-actions">
      <!-- Logged In Actions -->
      @if (isLoggedIn) {
        <mb-button size="lg" variant="secondary" [fullWidth]="true" (click)="goToAccount()">
          Mi Cuenta
        </mb-button>
        <mb-button size="lg" variant="primary" [fullWidth]="true" (click)="logout()">
          Cerrar Sesión
        </mb-button>
      }
      @else {
      <!-- Guest Actions -->
       <a routerLink="/auth/login" (click)="closeMobileMenu()">
          <mb-button size="lg" variant="primary" [fullWidth]="true">Iniciar Sesión</mb-button>
        </a>
      }
    </div>
  </div>
</div>

<!-- Dropdown Backdrop -->
<div class="navbar-backdrop" *ngIf="isServiciosOpen || isExploraOpen || isCountryOpen" (click)="closeAllDropdowns()"></div>
